// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"236":"2a545fcd","462":"bf8e91f7","584":"02964275","595":"78b624c4","605":"8798ef86","611":"7c6cf2cf","663":"c4acf6f8","812":"3878c2ad"}[chunkId] + ".js";
};